import * as Yup from "yup";

export const formikUser = {
    initialValues: {
        firstName: "",
        lastName: "",
        dob: "",
        roles: [],
        email : "",
        primaryPhone : "",
        secondaryPhone : "",
        jobTitle: "",
        address : "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        employer:"",
        department: "",
        defaultRoleId: "",
        about: "",
        language: []
    },
    validationSchema: Yup.object({
        firstName: Yup.string().required("Required Field"),
        lastName: Yup.string().required("Required Field"),
        roles: Yup.array().required("Required Field"),
        email: Yup.string().email("Invalid Email Format").required("Required Field"),
        primaryPhone: Yup.string().required("Required Field"),
        jobTitle: Yup.string().required("Required Field"),
        address: Yup.string().required("Required Field"),
        city: Yup.string().required("Required Field"),
        state: Yup.string().required("Required Field"),
        postalCode: Yup.string().required("Required Field"),
        country: Yup.string().required("Required Field")
    })
};


export const OrganizationEmailNotification = [
    { key: 'applicationUpdate', label: 'Application Update' },
    { key: 'newTask', label: 'Task Update' },
    { key: 'loginRequest', label: 'Login Request' },
    { key: 'newMessage', label: 'New Message' },
    { key: 'meetingUpdate', label: 'Meeting Update'},
    { key: 'newAssignment', label: 'New Assignment (Application/Patient)'},
    { key: 'supportTicketUpdate', label: 'Support Ticket Update'},
    { key: 'accessUpdate', label: 'Access & Privileges Update'},
    { key: 'workflowUpdate', label: 'Workflow Update'}
];

export const PlatformEmailNotification = [
    { key: 'applicationUpdate', label: 'Application Update' },
    { key: 'loginRequest', label: 'Login Request' },
    { key: 'newMessage', label: 'New Message' },
    { key: 'supportTicketUpdate', label: 'Support Ticket Update'},
    { key: 'accessUpdate', label: 'Access & Privileges Update'},
    { key: 'workflowUpdate', label: 'Workflow Update'}
];

export const PatientEmailNotification = [
    { key: 'applicationUpdate', label: 'Application Update' },
    { key: 'newTask', label: 'Task Update' },
    { key: 'loginRequest', label: 'Login Request' },
    { key: 'newMessage', label: 'New Message' },
    { key: 'meetingUpdate', label: 'Meeting Update'},
    { key: 'newAssignment', label: 'New Assignment (Application/Patient)'}
];
